import { API_URL, ChannelOverview_API_TOKEN, ENV } from '../../config';
import { IChannels, ILibraries } from '../content/types';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

interface ChannelOverviewResponse {
    channels: IChannels[];
    libraries: ILibraries[];
}

const fetchWithAuth = async (url: string, lang: string) => {
    url = applyPreproductionSettings(url);
    if (lang.includes('zh')) {
        url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
    }
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${ChannelOverview_API_TOKEN}`,
        },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
};

export const fetchChannelOverview = async (lang: string): Promise<ChannelOverviewResponse | null> => {
    try {
        const [channelsResponse, librariesResponse] = await Promise.all([
            fetchWithAuth(`${API_URL}/channels?populate=*&pagination[limit]=-1&sort=number:asc`, lang),
            fetchWithAuth(`${API_URL}/libraries?populate=*&pagination[limit]=-1&sort=number:asc`, lang)
        ]);

        const channels = channelsResponse.data.map((channel: any) => ({
            ...channel,
            attributes: {
                ...channel.attributes,
            },
        }));

        const libraries = librariesResponse.data.map((library: any) => ({
            ...library,
            attributes: {
                ...library.attributes,
            },
        }));

        const channelOverviewResponse: ChannelOverviewResponse = {
            channels,
            libraries,
        };

        console.log('fetchChannelOverview API Response:', channelOverviewResponse);
        return channelOverviewResponse;
    } catch (error) {
        console.error('Error fetching channel overview data.', error);
        return null; 
    }
};